import { render, staticRenderFns } from "./CustomerHubDialog.vue?vue&type=template&id=9a850784"
import script from "./CustomerHubDialog.vue?vue&type=script&lang=js"
export * from "./CustomerHubDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubDialog.vue?vue&type=style&index=0&id=9a850784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports